// authService.js

import { defineStore } from "pinia"
import { authenticate } from "@/plugins/axios"
import axiosInstance from "@/plugins/axios"
import { useRouter } from 'vue-router';

const router = useRouter();

export const useAuthService = defineStore({
  id: "authService",
  state: () => ({
    authData: {},
  }),
  actions: {
    async login(username, password) {
      try {
        const data = await authenticate(username, password)
        this.authDataFunction(data)

        return data.token
      } catch (error) {
        // Handle login errors
        // throw new Error(error)
      }
    },
    async handlepermission() {
      try {
        const response = await axiosInstance.get("/is-user-login")
        this.authData.permissions = response.data.data.permissions
        if (response?.data && response?.data?.data && response?.data?.data?.status === 401 ||response?.data?.data?.status === 500 ) {
          localStorage.removeItem('token');
          localStorage.removeItem('authService');
          router && router.push({ name: 'Login' });
        }
       
      } catch (error) {
        console.log("Error Response1:", error?.response?.status)
        if (error?.response && error?.response && error?.response?.status === 500) {
          // Handle the specific exception, for example, log it
          // console.error('SessionExpireTimeMiddleware exception:', error?.response?.status);
          // Redirect to login or handle as needed
          localStorage.removeItem('token');
          localStorage.removeItem('authService');
          router && router.push({ name: 'Login' });
        }
        if (error?.response && error?.response && error?.response?.status !== 200) {
          localStorage.removeItem('token');
          localStorage.removeItem('authService');
          router && router.push({ name: 'Login' });
        }
      }
    },

    async authDataFunction(data) {
      this.authData = data
      const defaulImage = "/placeholder.jpg"
      if (data.image && data.image != null && data.image != "null") {
        this.authData.image = data.image
      } else {
        this.authData.image = defaulImage
      }
    },
  },
  persist: true,
})
